import { createFileRoute } from '@tanstack/react-router';
import { ReactFlowProvider } from '@xyflow/react';
import z from 'zod';

import { LoomCanvasWithChat } from '@/components/features/loom/LoomCanvasWithChat';
import { LoomCommandRegistryProvider } from '@/components/features/loom/providers/LoomCommandRegistryProvider';
import { LoomStoreProvider } from '@/components/features/loom/providers/LoomStoreProvider';

export const Route = createFileRoute('/_protected/t/$tenantId/loom/new/')({
  component: RouteComponent,
  validateSearch: z.object({
    chatConversationId: z.string().optional().catch(undefined),
  }),
});

function RouteComponent() {
  const { chatConversationId } = Route.useSearch();

  return (
    <ReactFlowProvider>
      <LoomStoreProvider initialState={{ toolboxOpen: true }}>
        <LoomCommandRegistryProvider>
          <LoomCanvasWithChat chatConversationId={chatConversationId} />
        </LoomCommandRegistryProvider>
      </LoomStoreProvider>
    </ReactFlowProvider>
  );
}
